export class ImapConfiguration
{
	imapConfigurationId: number;
	imapConfigurationDate: Date;
	name: string;
	user: any;

	// Gmail API fields
	gmailSyncEnabled: boolean;
	gmailAuthType: number; // 0=IMAP_ONLY, 1=SERVICE_ACCOUNT, 2=OAUTH2, 3=API_KEY
	gmailCredentials: string;
	gmailHistoryId: number;

	// Gmail Bulk Sync progress (read-only from server)
	gmailBulkSyncStatus: string;
	gmailBulkSyncTotalListed: number;
	gmailBulkSyncTotalProcessed: number;
	gmailBulkSyncStartedAt: string;
	gmailBulkSyncLastActivityAt: string;
}
